import { Enums } from "../../enums/enums";
import { Constants } from "../../configs";
import { environment } from "../../../../environments/environment";
import moment from 'moment';

import { reportField } from "../../configs/trip-mode.config";
import { statusDispatch } from "../../configs/state-dispatches.config";
import { DispatchItemToExport, DispatchToExport } from "../../models";

export function validateDeliveryTypeCodes(tripMode) {
  return tripMode === Constants.tripMode.TRIP_BETWEEN_ENTITIES
    ? [
        Constants.SaleConfig.HOME_DELIVERY,
        Constants.SaleConfig.STORE_WITHDRAWAL,
      ]
    : [Constants.SaleConfig.HOME_DELIVERY];
}


export function validateStates(tripMode, dispatchStates){
  return dispatchStates && dispatchStates.length > 0
    ? dispatchStates
    : tripMode === Constants.tripMode.TRIP_BETWEEN_ENTITIES
    ? [Enums.DISPATCH_STATUS.PENDING_PICKING, Enums.DISPATCH_STATUS.PENDING_DISPATCH, Enums.DISPATCH_STATUS.CANCELLED]
      :  [Enums.DISPATCH_STATUS.PENDING_PICKING, Enums.DISPATCH_STATUS.PENDING_CUSTOMER_DISPATCH, Enums.DISPATCH_STATUS.CANCELLED];
}



export function removeDuplicates(listFilter): any[] {
  return listFilter.reduce((acc, curr) => {
    const exist = acc.find(i => i.dispatchId === curr.dispatchId && i.skuCode === curr.skuCode);
    if (exist) {
      const existIndex = acc.findIndex(i => i.dispatchId === curr.dispatchId && i.skuCode === curr.skuCode);
      acc[existIndex].processedAmount = Number(acc[existIndex].processedAmount) + Number(curr.processedAmount);
    } else {
      acc.push(curr);
    }
    return acc
  }, []);
}


export function createRequestForNewTrip(data: any):any {
  const authUser = JSON.parse(localStorage.getItem('inretail-auth'));
  const request = { ...data.form };
  request.plateNumber = data.form['license'];
  delete request.transport;
  delete request.license;
  delete request.dateOfTripShipping;
  delete request.hourDispatch;
  request.username = authUser.user.username;
  request.dispatchDate = new Date().toLocaleDateString('nl', { day: '2-digit', month: '2-digit', year: 'numeric' });
  request.entityCode = data.items[0].currentEntity;
  request.entityName = data.items[0].currentEntityName;
  request.dispatchTripDTOList = [];
  request.dispatchTripDTOList = addDispatchList(data);
  return request;
}

export function createRequestForMassiveTrips(data: any):any {
  const authUser = JSON.parse(localStorage.getItem('inretail-auth'));
  const companyCode = JSON.parse(localStorage.getItem(environment.sessionAuth)).user.entity.company.code;
  let request:any = { };
  let tripCompositions:any = [];
  request.companyCode = companyCode;
  request.username = authUser.user.username;
  request.eventDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
  request.event = reportField.TRIP_CREATED;
  request.origin = reportField.DISPATCH_MODULE;
  const items = JSON.parse(JSON.stringify(data.items));
  let trips = items.reduce((groups, item) => {
            const value = item['tripCode'];
            groups[value] = groups[value] || [];
            groups[value].push(item);
  return groups; }, []);

  Object.keys(trips).forEach((key) => {
    const value = trips[key];
    const tripComposition = {
      'tripCode': key,
      'entityCode': value[0].currentEntity,
      'entityName': value[0].currentEntityName,
      'tripType': reportField.REGULAR,
      'tripMode': Constants.tripMode.TRIP_TO_CUSTOMER,
      'origin': reportField.DAD,
      'dispatchCompositions': value.map(dispatch => {
        return {
          'saleNoteId': dispatch.saleNoteId,
          'dispatchId': dispatch.dispatchId,
          'dispatchOrder': dispatch.dispatchOrder,
          'itemCompositions': dispatch.dispatchItemsDto.filter(element => element.stateDispatch === true).map(sku => {
            return {
              'skuCode': sku.skuCode,
              'skuPartialSequence': sku.skuPartialSequence,
              'quantity': sku.processedAmount
            }
          })
        }
      }),
    };
    tripCompositions.push(tripComposition);
  });
  request.tripCompositions = tripCompositions;
  return request;
}

function addDispatchList(data:any): any[] {
  const items = JSON.parse(JSON.stringify(data.items));
  const dispatchTripDTOList = [];
  items.forEach((item) => {
    const itemRequest = {
      'saleNoteId': item.saleNoteId,
      'dispatchId': item.dispatchId,
      'dispatchItemsDTOList': item.dispatchItemsDto.filter(element => element.stateDispatch === true).map(sku => {
        return {
          'skuCode': sku.skuCode,
          'skuPartialSequence': sku.skuPartialSequence,
          'stateId': sku.stateId,
          'state': sku.state,
          'totalAmount': sku.totalAmount,
          'pendingAmount': sku.pendingAmount,
          'processedAmount': sku.processedAmount
        }
      }),
      'dispatchOrder': item.dispatchOrder
    };
    dispatchTripDTOList.push(itemRequest);
  });
  return dispatchTripDTOList;
}

export function  calculateQuantitiesOfDispatchItems(dispatchItems: any, requireStateDispatch?: boolean){
  return dispatchItems.map(item => {
    const canceledAmount = (item.canceledAmount != null) ? item.canceledAmount : 0;
    if ((item.processedAmount === 0 && item.pendingAmount === 0) || item.state !== statusDispatch.PENDING_PICKING) {
      let isTripBetweenEntities = item.state == statusDispatch.PENDING_DISPATCH;
      if (!item.totalAmount) {
        item.totalAmount = !isTripBetweenEntities? item.processedAmount + item.pendingAmount + canceledAmount: (item.processedAmount + item.pendingAmount);
      }
      item.processedAmount = item.pendingAmount;
      const pending = !isTripBetweenEntities ? (item.totalAmount - item.processedAmount - canceledAmount) : item.pendingAmount;
      item.pendingAmount = pending > 0 ? pending : 0;
    } else {
      if (!item.totalAmount) {
        item.totalAmount = item.processedAmount + item.pendingAmount;
      } else {
        item.totalAmount = item.totalAmount + canceledAmount
      }
      item.processedAmount = item.pendingAmount;
      const pending = item.totalAmount - item.processedAmount;
      item.pendingAmount = pending > 0 ? pending : 0;
    }
    if(requireStateDispatch){
      item.stateDispatch = true;
      if (item.canceledAmount && (item.canceledAmount === item.totalAmount)) {
        item['stateDispatch'] = false;
      }
    }
    return item;
  });
}

export function mappingByItemsExport(dispatches: DispatchToExport[]): DispatchItemToExport[] {
  let itemsReturn: DispatchItemToExport[] = [];
  dispatches.forEach(dispatch =>
    dispatch.dispatchItemsDto.forEach((item: any) => {
      itemsReturn.push({
        skuCode: item.skuCode,
        skuName: item.skuName,
        lpn: item.lpn,
        pendingAmount: item.pendingAmount,
        processedAmount: item.processedAmount,
        canceledAmount: item.canceledAmount,
        totalAmount: item.totalAmount,
        location: item.location,
        state: item.state,
        currentEntityName: item.currentEntityName,
        productLine: item.productLine,
        originalDeliveryDate: dispatch.originalDeliveryDate,
        deliveryDate: dispatch.deliveryDate,
        saleDate: dispatch.saleDate,
        paymentDate: dispatch.paymentDate,
        saleNoteId: dispatch.saleNoteId,
        dispatchId: dispatch.dispatchId,
        vtexCode: dispatch.vtexCode,
        deliveryTypeName: dispatch.deliveryTypeName,
        deliveryTypeCode: dispatch.deliveryTypeCode,
        dispatchTypeName: dispatch.dispatchTypeName,
        saleLocationName: dispatch.saleLocationName,
        nextEntityName: dispatch.nextEntityName,
        nextEntityAddress: dispatch.nextEntityAddress,
        deliveryAddress: dispatch.deliveryAddress,
        dispatchDepartment: dispatch.dispatchDepartment,
        dispatchProvince: dispatch.dispatchProvince,
        dispatchDistrict: dispatch.dispatchDistrict,
        dispatchZone: dispatch.dispatchZone,
        reference: dispatch.reference,
        customerDocumentNumber: dispatch.customerDocumentNumber,
        customer: dispatch.customer,
        mailCustomer: dispatch.mailCustomer,
        telephone: dispatch.telephone,
        withdrawPersonDoc: dispatch.withdrawPersonDoc,
        withdrawPerson: dispatch.withdrawPerson,
        startDateDeliveryWindow: dispatch.startDateDeliveryWindow,
        endDateDeliveryWindow: dispatch.endDateDeliveryWindow,
        geoLocalization: dispatch.geoLocalization,
        finalEntityCode: dispatch.finalEntityCode
      })
    })
  );
  return itemsReturn;
}
